export default "__VITE_ASSET__CiO5TIIH__"